<script setup lang="ts">
import { useTheme } from '@/composables/useTheme';
import { useMobilePreview } from '@/composables/useMobilePreview';

const { theme, toggle: toggleTheme } = useTheme();
const { enabled: mobile, toggle: toggleMobile } = useMobilePreview();

const isDesktop = window.matchMedia('(min-width: 900px)').matches;
</script>

<template>
  <div class="global-controls">
    <button class="ctrl-btn" :title="`Theme: ${theme}`" @click="toggleTheme">
      {{ theme === 'dark' ? '🌙' : '☀️' }}
    </button>
    <button v-if="isDesktop" class="ctrl-btn" :class="{ active: mobile }"
            :title="`Mobile preview: ${mobile ? 'on' : 'off'}`" @click="toggleMobile">
      📱
    </button>
  </div>
</template>

<style scoped>
.global-controls {
  position: fixed;
  top: max(14px, env(safe-area-inset-top));
  right: 14px;
  display: flex;
  gap: 8px;
  z-index: 100;
}
.ctrl-btn {
  width: 40px; height: 40px;
  border-radius: 999px;
  background: var(--card);
  border: 1px solid var(--border);
  color: var(--text);
  font-size: 18px;
  display: flex; align-items: center; justify-content: center;
  box-shadow: var(--shadow);
  transition: transform 0.05s ease, background 0.2s ease;
}
.ctrl-btn:active { transform: scale(0.92); }
.ctrl-btn.active { background: var(--primary); color: white; border-color: var(--primary); }
</style>
